import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';
import { getTranslation } from '../../providers/TranslationProvider';
import Logo from '../../svg/icons/logo-footer.svg';

const IconFooterLogo = (props) => {
  const { height, width } = props;
  return (
    <Icon
      component={Logo}
      height={height}
      name="logo"
      role="img"
      ariaLabel={getTranslation({ translationKey: 'resy_logo_right_this_way', fallback: 'Resy logo, right this way' })}
      width={width}
    />
  );
};

IconFooterLogo.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};

IconFooterLogo.defaultProps = {
  height: '34',
  width: '202',
};

IconFooterLogo.displayName = 'IconFooterLogo';

export default IconFooterLogo;
